// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"20":"7aa3e717","44":"eac969e8","83":"83cb6a20","426":"67d1398d","526":"39b38e3c","536":"fd2b870c","801":"02761f8e","842":"e55ce3f4","993":"85bdea3d"}[chunkId] + ".css";
};